import { styled } from '@mui/material';

export const Container = styled('div', {
  shouldForwardProp: (propName: string) =>
    propName !== 'type' && propName !== 'isReply' && propName !== 'greenVariant',
})<{ type: 'task' | 'comment'; isReply?: boolean; greenVariant?: boolean }>(
  ({ type, isReply, greenVariant, theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    marginTop: '0.25rem',
    backgroundColor: greenVariant ? theme.palette.accent.light : theme.palette.accent.light,
    borderRadius: '0.5rem',
    border: greenVariant
      ? `0.5px solid ${theme.palette.accent.main}40`
      : `0.5px solid ${theme.palette.accent.main}`,
    boxShadow: greenVariant
      ? `0 1px 6.2px 0 ${theme.palette.accent.main}33`
      : `0 2px 4px 0 ${theme.palette.accent.main}33`,
    padding: '0.5rem',
    overflow: 'visible',

    '& .ql-toolbar': {
      display: isReply || type === 'task' ? 'none' : 'block',
      border: 'none !important',
      padding: '0 !important',

      '.ql-formats': {
        marginRight: '0 !important',
      },
    },

    '& .ql-editor': {
      border: 'none',
      color: 'black',
    },

    '& .ql-container': {
      border: 'none !important',
    },
  }),
);

export const ButtonsList = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'type',
})<{ type: 'task' | 'comment' }>(({ type }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  marginTop: type === 'task' ? 0 : '0.25rem',
  justifyContent: 'space-between',
}));

export const PostCommentButton = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'greenVariant',
})<{ greenVariant?: boolean }>(({ greenVariant, theme }) => ({
  borderRadius: '1.625rem',
  // @ts-ignore
  backgroundColor: greenVariant ? theme.palette.accent.main : theme.palette.accent.main,
  padding: '0.25rem 0.95rem',
  cursor: 'pointer',

  WebkitUserSelect: 'none',
  userSelect: 'none',
  msUserSelect: 'none',

  color: 'white',
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: 400,
  lineHeight: '160%',
}));

export const PriorityContainer = styled('div')(({ theme }) => ({
  padding: '0.5rem 1rem',
  // @ts-ignore
  border: `1px solid ${theme.palette.blue[500]}`,
  borderTopWidth: 0,
  borderBottomLeftRadius: '0.5rem',
  borderBottomRightRadius: '0.5rem',
  display: 'flex',
  width: '100%',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const PriorityLabel = styled('p')(({ theme }) => ({
  margin: 0,
  color: theme.palette.grey[900],
  fontSize: '0.875rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: '150%',
}));

export const PriorityButtonsGroup = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 0.25rem;
`;

export const PriorityButton = styled('div', {
  shouldForwardProp: (propName: string) => propName !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  cursor: 'pointer',
  fontSize: '0.625rem',
  fontStyle: 'normal',
  fontWeight: 500,
  lineHeight: 'normal',
  textTransform: 'uppercase',
  padding: '0.12rem 0.25rem',
  // @ts-ignore
  color: active ? theme.palette.orange[700] : theme.palette.grey[900],
  // @ts-ignore
  backgroundColor: active ? theme.palette.orange[100] : 'white',
}));
